export class LocalStorageDto {
  storageKey: string;
  item: any;
  expirationDate?: Date;
}
